import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core";
import image from "../../../assets/images/googleB.png";

const GoogleButton = withStyles({
  root: {
    backgroundImage: `url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: 5,
    border: 0,
    height: "50px",
    width: "100%",
    maxWidth: "200px",
    minWidth: "145px",
  },
})(Button);

export default GoogleButton;
